<template>
    <div class="row filter-bar">
        <h4>Filtres:</h4>
        <div class="form-group form-group-default col-md-4">
            <label>Agence</label>
            <select2 :classList="['full-width', 'form-control', 'agency-field']" :options="agencies" 
                :multiple="true" v-model="selectedAgencies" placeholder="Choisir une agence">
            </select2>
        </div>
        <div class="form-group form-group-default input-group col-md-4">
            <label>Date</label>
            <input type="text" id="date-filter" class="form-control tip date-time-field" v-model="consumptionDate">
            <span class="input-group-addon">
                    <i class="fa fa-calendar"></i>
            </span>
        </div>
    </div>
</template>

<script>
    import Select2 from 'components/Form/Select2'

    export default {
        props: ["filters", "agencies"],

        components: {
            Select2
        },

        mounted () {
            this.$nextTick()
                .then(() => {
                    $('#date-filter', this.$el).datepicker({
                        format: "yyyy-mm-dd",
                        language: "fr",
                        autoclose: true,
                        title: "Date de consommation",
                    }).on('changeDate', (e) => {
                        this.consumptionDate = e.target.value
                    })
                })
        },

        computed: {
            selectedAgencies: {
                get () {
                    return this.filters.agencies
                }, set (value) {
                    this.$emit('update', { agencies: value })
                }
            },

            consumptionDate: {
                get () {
                    return this.filters.date
                }, set (value) {
                    this.$emit('update', { date: value })
                }
            }
        }
    }
</script>

<style scoped>
    .filter-bar {
        padding: 20px 20px 20px 20px;
    }

    .date-time-field, .agency-field {
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// client/components/ConsumptionProducts/FiltersBar.vue